import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        {
            question: "Are your security guards SIA licensed?",
            answer: "Yes, all our security professionals are fully SIA (Security Industry Authority) licensed. We also conduct thorough background checks and regular training to ensure the highest standards of professionalism and compliance with UK security regulations."
        },
        {
            question: "What areas do you cover?",
            answer: "We are headquartered in Birmingham (Castle Vale, B35 6LJ) and operate across the Midlands, covering Birmingham, Coventry, Wolverhampton, and the wider West and East Midlands region."
        },
        {
            question: "Do you provide security monitoring?",
            answer: "Yes. Our security officers conduct regular structured patrols and use advanced technology including thermal imaging for perimeter monitoring. Our management team is available via phone during extended hours for any urgent escalations."
        },
        {
            question: "Can you provide security for short-term contracts?",
            answer: "Yes, we offer flexible security solutions for both long-term contracts and short-term requirements, including temporary construction site protection and retail security cover across the Midlands."
        },
        {
            question: "How quickly can you deploy security to my site?",
            answer: "In many cases, we can deploy security personnel within 4 to 24 hours of a request, depending on the location and specific requirements of the site."
        },
        {
            question: "What services do you offer?",
            answer: "Our approved services are: Construction Site security, Building Site security, Solar Panel security, Retail Security, Door Supervisor services, and Corporate security — all delivered by SIA-licensed professionals across the Midlands."
        },
        {
            question: "How do you ensure the quality of your guards?",
            answer: "We use a rigorous multi-stage vetting process, including 5-year work history verification and personal references. Once hired, guards undergo site-specific induction and are monitored via regular supervisor spot-checks."
        }
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="faq-page">
            <div className="faq-hero" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/Pages%20Images/31.png'})` }}>
                <div className="hero-overlay"></div>
                <h1>Frequently Asked Questions</h1>
                <p>Everything you need to know about our professional security services and standards.</p>
            </div>

            <div className="faq-container">
                <div className="faq-intro">
                    <h2>Got Questions?</h2>
                    <p>We believe in transparency and professional excellence. If your question isn't answered here, please don't hesitate to contact us directly.</p>
                </div>

                <div className="faq-list">
                    {faqData.map((item, index) => (
                        <div 
                            key={index} 
                            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                            onClick={() => toggleAccordion(index)}
                        >
                            <div className="faq-question">
                                <h3>{item.question}</h3>
                                <span className="faq-icon">
                                    {activeIndex === index ? '−' : '+'}
                                </span>
                            </div>
                            <div className="faq-answer">
                                <p>{item.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="faq-cta">
                    <h3>Still have questions?</h3>
                    <p>Our expert team is ready to discuss your specific security requirements.</p>
                    <a href="/contact" className="contact-btn">Get in Touch</a>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
